export let availableColors = [
    'air',
    'default',
    'error',
    'gray',
    'info',
    'light-gray',
    'light',
    'main',
    'minor',
    'plain',
    'text',
    'valid',
    'warning',
]

export let coloringMixin = {
    props: {
        color: {
            type: String,
            default: 'default',
            validator: value => availableColors.indexOf(value) !== -1,
            _descr: availableColors.join('|'),
        },
    },
}
